<template>
  <div class="home">
    <StatsDisplay />
  </div>
</template>

<script>
import StatsDisplay from '@/components/StatsDisplay.vue'

export default {
  name: 'HomeView',
  components: {
    StatsDisplay
  }
}
</script>